import { cloneAdBreak } from '../../utils/ad-break-utils';
function sortAdBreaks(adBreaks) {
    var sortedBreaks = adBreaks.sort(function(ab1, ab2) {
        if (ab1.position === 'start' || ab2.position === 'end') {
            return -1;
        }
        if (ab1.position === 'end' || ab2.position === 'start') {
            return 1;
        }
        return ab1.position - ab2.position;
    });
    return sortedBreaks;
}
export function toAdBreaksWithPositionIncludingAds(adBreaksWithContentPosition) {
    var sortedAdBreaksWithContentPosition = sortAdBreaks(adBreaksWithContentPosition);
    var adBreaksWithPositionIncludingAds = sortedAdBreaksWithContentPosition.reduce(function(acc, adBreakWithContentPosition) {
        var adBreak = cloneAdBreak(adBreakWithContentPosition);
        var _adBreak_expectedDuration;
        var breakDuration = (_adBreak_expectedDuration = adBreak.expectedDuration) !== null && _adBreak_expectedDuration !== void 0 ? _adBreak_expectedDuration : adBreak.ads.reduce(function(dur, ad) {
            return dur + ad.expectedDuration;
        }, 0);
        if (adBreak.position === 'start') {
            adBreak.position = 0;
        }
        if (typeof adBreak.position === 'number') {
            adBreak.position = adBreak.position + acc.accumulatedBreakDuration;
        }
        return {
            accumulatedBreakDuration: acc.accumulatedBreakDuration + breakDuration,
            adBreaksWithPositionIncludingAds: acc.adBreaksWithPositionIncludingAds.concat([
                adBreak
            ])
        };
    }, {
        accumulatedBreakDuration: 0,
        adBreaksWithPositionIncludingAds: []
    }).adBreaksWithPositionIncludingAds;
    return adBreaksWithPositionIncludingAds;
}

//# sourceMappingURL=ad-break-time-conversion.js.map